import React, { useContext } from "react";
import { FilterContext } from "../../context/Filter";

const AnalysisTable = ({ faultData }) => {
  const rawData = faultData || {};
  // console.log(rawData, "-----");

  if (!rawData || Object.keys(rawData).length === 0) {
    return (
      <div className="p-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700">
        No data found. Please select valid parameters.
      </div>
    );
  }

  const lampMapping = {
    // vihicle_count: {
    //   fault: "User Input Vehicle Count",
    //   code: "F003",
    //   getValue: (data) => data?.vihicle_count?.value ?? 0,
    // },
    // total_distance_sum_ve: {
    //   fault: "Total Distinct Vehicles with Fault Code",
    //   code: "F003",
    //   getValue: (data) => data?.total_distance_sum_ve ?? 0,
    // },
    total_distance_sum_ve: {
      fault: "Total Distinct Vehicles with Fault Code",
      code: "F003",
      getValue: (data) => data?.vihicle_count ?? 0,
    },
    red_stop_data: {
      fault: "Red Stop Lamp",
      code: "F003",
      getValue: (data) =>
        data?.red_stop_data?.[0]?.vehicleid_red_stop?.value ?? 0,
    },
    amber_warning_data: {
      fault: "Amber Warning Lamp",
      code: "F001",
      getValue: (data) =>
        data?.amber_warning_data?.[0]?.vehicleid_amber_warning?.value ?? 0,
    },
    malfunction_data: {
      fault: "Malfunction Indicator Lamp",
      code: "F002",
      getValue: (data) =>
        data?.malfunction_data?.[0]?.vehicleid_malfunction?.value ?? 0,
    },
    protect_lamp_data: {
      fault: "Protect Lamp",
      code: "F003",
      getValue: (data) =>
        data?.protect_lamp_data?.[0]?.vehicleid_protect?.value ?? 0,
    },
  };

  const result = Object.entries(lampMapping).map(([key, config]) => ({
    fault: config.fault,
    code: config.code,
    count: config.getValue(rawData),
  }));

  return (
    <div className="w-96 bg-white border border-gray-300 rounded-md overflow-hidden md:w-1/2">
      <table className="w-full border border-gray-300 text-left rounded-md overflow-hidden">
        <thead className="bg-[#056DB3] text-white">
          <tr>
            <th className="text-md pl-2 p-1">Description</th>
            <th className="text-md pl-2 p-1">Value</th>
          </tr>
        </thead>
        <tbody>
          {result.map((row, idx) => (
            <tr key={idx} className="odd:bg-gray-200 even:bg-gray-50">
              <td className="py-2 px-4">{row.fault}</td>
              <td className="py-2 px-4">{row.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AnalysisTable;
